import { getExecuteLawNote,getNoteDetails,getCompanyReply,getCompanyReplyDetails } from "../../api/config/modules/EnforcementNotes";

const state = {
    getExecuteLawNote: {},
    getNoteDetails: {},
    getCompanyReply: {},
    getCompanyReplyDetails: {}
};

const mutations = {
  SET_GETEXECUTELAWNOTE: (state, getExecuteLawNote) => {
    state.getExecuteLawNote = getExecuteLawNote;
  },
  SET_GETNOTEDETAILS: (state, getNoteDetails) => {
    state.getNoteDetails = getNoteDetails;
  },
  SET_GETCOMPANYREPLY: (state, getCompanyReply) => {
    state.getCompanyReply = getCompanyReply;
  },
  SET_GETCOMPANYREPLYDETAILS: (state, getCompanyReplyDetails) => {
    state.getCompanyReplyDetails = getCompanyReplyDetails;
  },
};

const actions = {
  GET_GETEXECUTELAWNOTE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getExecuteLawNote(data)
        .then((res) => {
          commit("SET_GETEXECUTELAWNOTE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETNOTEDETAILS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getNoteDetails(data)
        .then((res) => {
          commit("SET_GETNOTEDETAILS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCOMPANYREPLY: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCompanyReply(data)
        .then((res) => {
          commit("SET_GETCOMPANYREPLY", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCOMPANYREPLYDETAILS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCompanyReplyDetails(data)
        .then((res) => {
          commit("SET_GETCOMPANYREPLYDETAILS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
